var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billet-view"},[_c('div',{staticClass:"columns my-6"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"container"},[_c('header-section',{attrs:{"is-credit-card":_vm.orderType === 'credit_card'}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }